"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a MESSAGING_RECEIVER_CLIENT request.
 */
var MessagingClientForwardSendRequest = /** @class */ (function () {
    /**
     * Create a new MessagingClientForwardSendRequest instance
     *
     */
    function MessagingClientForwardSendRequest(cid, sessionID, path, properties, dataType, content) {
        this.cid = cid;
        this.sessionID = sessionID;
        this.path = path;
        this.properties = properties;
        this.dataType = dataType;
        this.content = content;
    }
    return MessagingClientForwardSendRequest;
}());
exports.MessagingClientForwardSendRequest = MessagingClientForwardSendRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/messaging-client-forward-send-request.js
// module id = 1217
// module chunks = 1